import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiGet } from '../../api/client';

const MONTH_NAMES = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

function formatMonth(ym: string) {
  const [y, m] = ym.split('-');
  return `${MONTH_NAMES[parseInt(m, 10) - 1]} ${y}`;
}

export default function AdminMonths() {
  const [months, setMonths] = useState<string[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    apiGet<{ months: string[] }>('/api/admin/months')
      .then((d) => setMonths(d.months))
      .catch((e: Error) => setErr(e.message));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dönemler (Aylar)</h1>
      {err && <div className="text-red-600 mb-4">{err}</div>}
      
      {months === null ? (
        <div className="text-slate-500">Yükleniyor…</div>
      ) : months.length === 0 ? (
        <div className="card p-8 text-center text-slate-500">Sistemde henüz hiç fiş yok.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {months.map((m) => (
            <Link
              key={m}
              to={`/yonetim/donemler/${m}`}
              className="card p-6 hover:shadow-md hover:border-brand-400 transition-all flex items-center justify-between group cursor-pointer border border-transparent"
            >
              <div className="flex items-center gap-3">
                <span className="text-4xl leading-none">📁</span>
                <span className="font-semibold text-lg text-slate-800">{formatMonth(m)}</span>
              </div>
              <span className="text-brand-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Aç →
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
